export function toUnderscore(value: string): string {
  return value?.split(/\.?(?=[A-Z])/)?.join('_')?.replaceAll('::_', '/')?.toLowerCase() || "";
}

export function toKebab(value: string, target?: string): string {
  if (target === 'css') {
    return value?.split(/\.?(?=[A-Z])/)?.join('-')?.replaceAll('::-', '-')?.toLowerCase() || "";
  }

  return value?.split(/\.?(?=[A-Z])/)?.join('-')?.replaceAll('::-', '/')?.toLowerCase() || "";
}
